function toggleFormsVisibility(selector) {
    const selectedForm = document.querySelector(`[d-check="${selector}"]`)
    const otherForm = document.querySelector(`[d-check]:not([d-check="${selector}"])`)
    
    if (!selectedForm) return

    otherForm.style = otherForm.querySelector('.popup-special-offers__block-inputs').style = 'opacity: 0; max-height: 0px; pointer-events: none;'
    selectedForm.style = selectedForm.querySelector('.popup-special-offers__block-inputs').style= 'opacity: 1;'
}